export const MOBILE_BUTTON_TYPES = {
  SECTION: 'section',
  NORMAL: 'normal',
};
